import Vue from "vue";
import Vuex from "vuex";

import createPersistedState from "vuex-persistedstate";

import common from "./modules/common";
import auth from "./modules/auth";

import event from "./modules/event";
import eventCatalog from "./modules/eventCatalog";
import { notification } from "@v2/entities/notification/model";

import passes from "./modules/passes";
import documents from "./modules/documents";

import services from "./modules/services";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    common,
    auth,
    event,
    eventCatalog,
    passes,
    documents,
    notification,
    services
  },
  strict: false, // process.env.NODE_ENV !== "production"
  plugins: [
    createPersistedState({
      key: "vuex",
      paths: ["auth"]
    })
  ]
});
